import React, { useState, useEffect, useRef, useCallback } from 'react';
import { FaHome, FaPhone, FaEnvelope } from 'react-icons/fa';
import styles from './ContactInfo.module.css';

const CONTACT_DATA = [
  {
    id: 'address',
    icon: FaHome,
    text: "Come see our latest drone tech in action! We're happy to welcome you!",
    contactInfo: 'MEDA Building, Kakkanad,\nErnakulam, Kerala, India - 682037',
    isLink: false
  },
  {
    id: 'phone',
    icon: FaPhone,
    text: 'Need quick answers or expert advice? Our team is ready to help.',
    contactInfo: '+91 484 299 3399',
    href: 'tel:+914842993399',
    isLink: true
  },
  {
    id: 'email',
    icon: FaEnvelope,
    text: 'Have a query or project idea? Drop us an email anytime.',
    contactInfo: 'info@axldrone.com',
    href: 'mailto:info@axldrone.com',
    isLink: true
  }
];

const ContactCard = React.memo(({ contact, isShaking }) => {
  const IconComponent = contact.icon;

  const contactInfo = contact.isLink ? (
    <p className={styles.contactText}>
      <a 
        href={contact.href} 
        className={styles.contactLink}
        aria-label={`Contact via ${contact.id}`}
      >
        {contact.contactInfo}
      </a>
    </p>
  ) : (
    <p className={styles.contactText}>
      {contact.contactInfo.split('\n').map((line, index, arr) => (
        <React.Fragment key={index}>
          {line}
          {index < arr.length - 1 && <br />}
        </React.Fragment>
      ))}
    </p>
  );

  return (
    <div className={styles.card}>
      <span className={`${styles.iconWrapper} ${isShaking ? styles.shake : ''}`}>
        <IconComponent size={62} className={styles.icon} />
      </span>
      <p className={styles.description}>{contact.text}</p>
      {contactInfo}
    </div>
  );
});

ContactCard.displayName = 'ContactCard';

const ContactInfo = () => {
  const [isShaking, setIsShaking] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const sectionRef = useRef(null);

  const triggerShake = useCallback(() => {
    setIsShaking(true);
    setTimeout(() => setIsShaking(false), 600);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          triggerShake();
        } else {
          setIsInView(false);
        }
      },
      { threshold: 0.5 }
    );

    const currentRef = sectionRef.current;
    if (currentRef) observer.observe(currentRef);

    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, [triggerShake]);

  useEffect(() => {
    if (!isInView) return;
    const interval = setInterval(triggerShake, 4000);
    return () => clearInterval(interval);
  }, [isInView, triggerShake]);

  return (
    <section ref={sectionRef} className={styles.container}>
      <div className={styles.cardsWrapper}>
        {CONTACT_DATA.map(contact => (
          <ContactCard 
            key={contact.id} 
            contact={contact} 
            isShaking={isShaking}
          />
        ))}
      </div>
    </section>
  );
};

export default ContactInfo;
